import { useEffect, useState } from "react";
import { RootStore, useAppSelector } from "../../../../store/store";
import { renderDynamicUrlFromComponentLevelState } from "../../../../helpers/utils/urlHelper";
import axiosInstance from "../../../../apiConfigs/axiosInstance";
import BoxShadow from "../../../../shared/BoxShadow/BoxShadow";
import SearchBar from "../../../../shared/SearchBar/SearchBar";
import Table, { TableBody, TableHeading } from "../../../../shared/Table/Table";
import Empty from "../../../../shared/Empty/Empty";
import Loader from "../UserAllTabs/Loader";


function LiveDataAaystNotifiedUsers() {
  const [searchText, setSearchText] = useState("");
  const [sessionUsers, setSessionUsers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading,setLoading] = useState(false);

  const configState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });

  useEffect(() => {
    fetchSessionUsers();
  }, []);

  useEffect(() => {
    filterData();
  }, [searchText]);

  const filterData = () => {
    const lowercasedSearch = searchText.toLowerCase();
    const filtered = sessionUsers.filter((item: any) =>
      item?.email.toLowerCase().includes(lowercasedSearch) || 
      item?.for.toLowerCase().includes(lowercasedSearch)
    );
    setFilteredData(filtered);
  };

  const fetchSessionUsers = async () => {
    try {
      setLoading(true);
      const dynamic_url = renderDynamicUrlFromComponentLevelState(configState);
      await axiosInstance.get(`${dynamic_url}/upcoming-session-users?for=live_data_analyst`).then((res:any) => {
        if (res.data.data) {
          const sortedData = res.data.data.sort((a: any, b: any) => {
            return new Date(b.date).getTime() - new Date(a.date).getTime();
          });
          setSessionUsers(sortedData);
          setFilteredData(sortedData);
        }
      });
      setLoading(false)
    } catch (error) {
      console.log(error)
      
    }
    finally{
      setLoading(false);
    }
  };



  return (
    <div>
      <BoxShadow>
        <div className="subscribers-bottom  mt-7">
          <div className="sh-table-top">
            <div className="left">Upcoming Live Data Analyst  Users</div>
            <div className="right subscriber__table__head__right__section">
              <div className="searchbar__wrapper">
                {" "}
                <SearchBar value={searchText} setValue={setSearchText}/>
              </div>

            </div>
          </div>
          <div className="subscriber__talbe__section">
            <Table
              heading={
                <TableHeading>
                  <th>S.N.</th>
                  <th>Email Address</th>
                  <th className="">Created At</th>
                  <th className="">Course</th>
                  <th className="hide__text">.</th>
                </TableHeading>
              }
            >
              <TableBody>
                {filteredData.length > 0 && filteredData.map((item: any, index) => {
                  return (
                    <tr key={item.id}>
                      <td className="subscriber_name">{index+1}</td>
                      <td className="subscriber_name">{item.email}</td>
                      <td className="">{item.date}</td>
                      <td className="">{item.for.toUpperCase()}</td>
                      <td className="hide__text">.</td>
                    </tr>
                  );
                })}
              </TableBody>
            </Table>

            {filteredData.length === 0 && !loading && <div className="mt-5 handle__empty__container__div">
                  <Empty emptyText="It seems empty." custombg={true} />
                </div>}
              {
                filteredData.length === 0 && loading && (
                  <Loader/>
                )
              }
          </div>
        </div>
      </BoxShadow>
      {/* <div className="pagination__section">
        <PaginateButton
          rowPerView={10}
          paginate={handlePagination}
          totalRows={sessionUsers.length}
        />
      </div> */}
    </div>
  );
}

export default LiveDataAaystNotifiedUsers;
